import MenuSelector from "@arelia-components/ui-atoms/menu-selector/MenuSelector";
import { MenuType } from "@arelia-components/ui-atoms/menu-selector/models";
import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent, Switch } from "@mui/material";
import { sortByMenu } from "../constant";
import { CustomersSorting, Tag } from "../models";

type Props = {
  sortCustomersBy: CustomersSorting;
  setSortCustomersBy: (value: CustomersSorting) => void;
  includeTestUsers: boolean;
  setIncludeTestUsers: (value: boolean) => void;
  selectedTags: Tag[];
  setSelectedTags: (value: Tag[]) => void;
}

export function CustomersFilters({
  setSortCustomersBy,
  sortCustomersBy,
  includeTestUsers,
  setIncludeTestUsers,
  selectedTags,
  setSelectedTags
}: Props) {
  const values: Tag[] = [
    { prop: "status", val: "Registered" },
    { prop: "status", val: "Active" },
    { prop: "status", val: "Inactive" },
    { prop: "status", val: "Closed" },
    { prop: "role", val: "Ambassador" },
  ];

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const valueArray = event.target.value as string[];
    const newSelectedTags = valueArray.map(val => values.find(tag => tag.val === val));
    setSelectedTags(newSelectedTags as Tag[]);
  };

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.filters}>
        <MenuSelector
          menuType={MenuType.contained}
          menuItems={sortByMenu}
          selectedValue={sortCustomersBy}
          onClick={setSortCustomersBy}
        ></MenuSelector>

        <FormControl sx={{ width: 300 }} size="small">
          <InputLabel>Tags</InputLabel>
          <Select
            multiple
            value={selectedTags.map(tag => tag.val)}
            onChange={handleChange}
            input={<OutlinedInput label="Tags" />}
            renderValue={(selected) => selected.map(tag => tag).join(', ')}
            sx={styles.select}
          >
            {values.map((tag, i) => (
              <MenuItem key={i} value={tag.val}>
                <Checkbox checked={selectedTags.some(t => t.val === tag.val)} />
                <ListItemText primary={tag.val} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <FormControlLabel
        control={
          <Switch value={includeTestUsers} onChange={(e) => setIncludeTestUsers(e.target.checked)} />
        }
        value="start"
        label="Display test accounts"
        labelPlacement="start" />
    </Box>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  filters: {
    display: "flex",
    gap: "20px",
    alignItems: "center"
  },
  select: {
    bgcolor: 'white',
    margin: '0'
  }
}